import { FC } from "react";
import { SvgIcon } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

import "./style.scss";
import { ReactComponent as PlusCircleIcon } from "../../assets/plus-circle.icon.svg";

export enum KnowledgeBaseMenuItemType {
    stroke = "stroke",
    fill = "fill",
    gradient = "gradient"
}

export interface KnowledgeBaseMenuItem {
    type: KnowledgeBaseMenuItemType;
    icon: FC<React.SVGProps<SVGSVGElement>>;
    title: string;
    role?: string;
    kbId?: string;
    logoUrl?: string;
    disabled?: boolean;
    action: () => void;
}

export const KnowledgeBaseMenu = ({
    className = "",
    items,
    currentKnowledgeBaseId,
    collapsed = false,
    addAssistantAction,
    addAssistantDisabled = false
}: {
    className?: string;
    items: KnowledgeBaseMenuItem[];
    currentKnowledgeBaseId?: string;
    collapsed?: boolean;
    addAssistantAction?: () => void;
    addAssistantDisabled?: boolean;
}) => {
    const handleMenuItem = (item: KnowledgeBaseMenuItem) => {
        item.action();
    };

    const isCurrentKB = (item: KnowledgeBaseMenuItem) => {
        return !!currentKnowledgeBaseId && currentKnowledgeBaseId === item.kbId;
    };

    return (
        <div className={`kb-panel${collapsed ? " kb-panel--collapsed" : ""} ${className}`}>
            <div className="kb-panel-list">
                {items.map(item => (
                    <button
                        type="button"
                        key={item.kbId ?? item.title}
                        className={`kb-panel-item kb-panel-item--${item.type}${isCurrentKB(item) ? " kb-panel-item--selected" : ""}${item.disabled ? " kb-panel-item--disabled" : ""}`}
                        disabled={item.disabled}
                        aria-current={isCurrentKB(item) ? "true" : undefined}
                        onClick={() => handleMenuItem(item)}
                    >
                        {item.logoUrl ? (
                            <img
                                className="kb-panel-item__logo"
                                src={item.logoUrl}
                                alt={item.title}
                            />
                        ) : (
                            <SvgIcon
                                className="kb-panel-item__icon"
                                component={item.icon}
                                inheritViewBox
                            />
                        )}
                        <span className="kb-panel-item__title">
                            {item.title}
                            {!!item.role && item.role !== "user" && (
                                <span className="kb-panel-item__role">{` (${item.role})`}</span>
                            )}
                        </span>
                        {isCurrentKB(item) && <CheckIcon className="kb-panel-item__check" />}
                    </button>
                ))}
            </div>
            {addAssistantAction && (
                <button
                    type="button"
                    className={`kb-panel-add${addAssistantDisabled ? " kb-panel-add--disabled" : ""}`}
                    disabled={addAssistantDisabled}
                    onClick={addAssistantAction}
                >
                    <SvgIcon
                        className="kb-panel-add__icon"
                        component={PlusCircleIcon}
                        inheritViewBox
                    />
                    <span className="kb-panel-add__title">Add Assistant</span>
                </button>
            )}
        </div>
    );
};
